import Vue from 'vue'
import { apolloProvider } from './vue-apollo'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'
import { VueMaskDirective } from 'v-mask'
import Constants from '@/Constants/Constants'
import VueGallery from 'vue-gallery'

Vue.directive('mask', VueMaskDirective)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC1W5a2sBUgbyjncF5Bik08A70cKv7QVRU',
    region: 'IN',
    language: 'en',
    libraries: 'places,drawing,visualization',
  },
  installComponents: true,
})
Vue.component('gallery', VueGallery);
Vue.config.productionTip = false
Vue.mixin({
  filters: {
    currencyFormatter (value) {
      return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2, minimumFractionDigits: 0,
        style: 'currency', currency: 'INR',
      }).format(value)
    },
  },
  methods: {
    dateTimeFilter (val) {
      return val ? moment(val).format('DD MMM YYYY @ hh:mm A') : '-'
    },
    statusFormatter (val) {
      return val ? val.toString().replace(/[_-]/g, ' ') : '-'
    },
    checkVal (val) { return val ? val : '-' },
    dateFormatter (val) {
      return val ? moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'
    },
    imgWpx(path, size, type){
      let sizes = path.split('/')[2]?.split('-')||[];
      if(!sizes.length || type === 'VIDEO') return  Constants.api_base_url + path;
      if(!sizes.includes(String(size))) size = sizes.pop();
      return  Constants.api_base_url + 'images/uploads/w-'+size+'/' +path.split('/').pop();
    },
    currencyFormatter (value) {
      return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2, minimumFractionDigits: 0,
        style: 'currency', currency: 'INR',
      }).format(value)
    },
  },
})

new Vue({
  router,
  vuetify,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')
